// theme.tsx
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#1a1a1a',
            paper: '#27272a'
        },
        primary: {
            main: '#e8e8e8ff'
        },
        secondary: {
            main: '#a855f7'
        },
        info: {
            main: '#3b82f6'
        },
        success: {
            main: '#22c55e'
        },
        warning: {
            main: '#eab308'
        }
    },
    typography: {
        fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
        h4: { fontWeight: 700 },
        h6: { fontWeight: 600 },
        subtitle1: { color: '#ccc' },
        body2: { color: '#999' },
        caption: { color: '#aaa' }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 4
                }
            }
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: { height: 10, borderRadius: 5 },
                bar: { borderRadius: 5 }
            }
        }
    }
});

export default theme;